app.factory('userService', function($http) {
    return {
        exists: function(params) {
            return $http.post('/administration/users/exists', {
                params: params
            });
        },
        activate: function(ids) {
            return $http.post('/administration/users/activate', ids);
        },
        deactivate: function(ids) {
            return $http.post('/administration/users/deactivate', ids);
        }
    }
});
